import React from 'react';

export default () => (
  <svg 
    width="14"
    height="14"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="#000000"
  >
      <g stroke="none" strokeWidth="1" fillRule="evenodd">
          <g transform="translate(0.000000, -40.000000)" fillRule="nonzero">
              <g transform="translate(0.000000, 40.000000)">
                  <path d="M7,0 C3.13400675,0 0,3.13400675 0,7 C0,10.8659932 3.13400675,14 7,14 C10.8659932,14 14,10.8659932 14,7 C13.9954997,3.13587236 10.8641276,0.00450027801 7,0 Z M11.04075,4.78333333 L7.04783333,10.2019167 C6.95260626,10.3282606 6.81060815,10.4110446 6.65374609,10.4316671 C6.49688402,10.4522895 6.33831395,10.4090207 6.21366667,10.3115833 L3.36233333,8.03191667 C3.11072161,7.83056285 3.06997952,7.46336173 3.27133333,7.21175 C3.47268715,6.96013827 3.83988827,6.91939618 4.0915,7.12075 L6.46916667,9.023 L10.1015833,4.09325 C10.2206953,3.91451084 10.4283965,3.81568988 10.6422234,3.83602189 C10.8560503,3.85635389 11.0414047,3.99254904 11.1246954,4.19053391 C11.2079861,4.38851878 11.1757363,4.61625831 11.04075,4.78333333 Z" id="Shape" />
              </g>
          </g>
      </g>
  </svg>
);